const config = [
  {
    component: 'ZlmTitle',
    options: {
      size: 'medium',
      text: '项目基本情况',
    },
  },
  {
    component: 'ZlmNormalDetail',
    options: {
      data: {},
    },
  },
  {
    component: 'ZlmTitle',
    options: {
      size: 'medium',
      text: '补遗澄清',
    },
  },
  {
    component: 'ZlmNormalDetail',
    options: {
      data: {},
    },
    events: {},
  },
]

const mixin = {
  data() {
    return {
      config: JSON.parse(JSON.stringify(config)),
    }
  },
  methods: {
    getData() {
      this.$request.post(`/transformToAfter/app/home/bybgDetail`, {
        guid: this.$route.query.ggGuid,
      }, { showLoading: true }).then((res) => {
        this.config[1].options.data = {
          '公告名称': res.data.ggName,
          '项目名称': res.data.projectName,
          '标段/包名称': res.data.bdName,
          '标段/包编号': res.data.bdBH,
          '变更标题': res.data.bgTitle,
        }
        if (res.data.xiangmuXingzhi === 3) {
          this.config[1].options.data['经营资产交易类型'] = res.data.jyzcTransType === 1 ? '资产处置' : '租赁'
        }
        this.config[3].options.data = {
          'html_补遗公告内容': res.data.ggContent,
          'file_补遗澄清文件': res.data.fuJianArr.length ? {
            name: res.data.fuJianArr[0].ggFuJianName,
            url: res.data.fuJianArr[0].ggFuJianUrl,
          } : {},
          '获取开始时间': this.$util.getTime(res.data.huoQuStartTime, 'YYYY-MM-DD HH:mm:ss'),
          '获取结束时间': this.$util.getTime(res.data.huoQuEndTime, 'YYYY-MM-DD HH:mm:ss'),
          '澄清截至时间': this.$util.getTime(res.data.daYiEndTime, 'YYYY-MM-DD HH:mm:ss'),
          '截标/开标时间': this.$util.getTime(res.data.kbTime, 'YYYY-MM-DD HH:mm:ss'),
        }

        this.config[3].events.fileClick = (data) => {
          if (data.data[data.key]) {
            // window.open(data.data[data.key].url)
            // eslint-disable-next-line no-undef
            downloadFile.postMessage(JSON.stringify({
              url: data.data[data.key].url,
              name: data.data[data.key].name,
            }))
          }
        }
      })
    },
  },
}

module.exports = {
  config,
  mixin,
}
